import { Col, Form, Input, Row, Typography } from "antd";
import { BOM } from "../../../../../services/definedMethod";
const { Text } = Typography;

const BalanceManagement = (props) => {
  const { onFinish, form, formData, glDetail } = props;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const yesNo = (value) =>
    value === true ? "Yes" : value === false ? "No" : "-";
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Opening Balance</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(BOM.FormatAmount(glDetail?.openingBalance))}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Minimum Balance Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                BOM.FormatAmount(glDetail?.minimumBalanceAllowed),
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Maximum Balance Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                BOM.FormatAmount(glDetail?.maximumBalanceAllowed),
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Overdraft Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.overdraftAllowed)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default BalanceManagement;
